import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import ActionsService from '@/services/services/actions.service';
import BaseModule from '@/store/baseModule';
import marketTypes from '@/store/modules/properties/constants';

const attributesObjRef = {
  market_type: {
    ...marketTypes,
    values: marketTypes.values.map((item) => ({ ...item, shortname: item.id })),
  },
  staffs_in_charge_id: {
    noFilter: true,
    type: '$instr~,',
    values: [],
  },
  author_id: {
    noFilter: true,
    values: [],
  },
};

export default (store) => {
  store.registerModule(
    'actions',
    new BaseModule({
      searchAttributesArray: [
        'node_associated_code',
        'node_associated_name',
        'node_associated_shortname',
        'description',
      ],
      attributesObjRef,
      serviceAPI: ActionsService,
      makeQueryParams: makeListRequest({
        navFullIdField: 'node_associated_nav_full_id',
        dateField: 'deadline_datetime',
        useEntities: true,
      }),
    })
  );
};
